var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25381 10C6.83456 10 6.60147 10.485 6.86338 10.8123L9.82307 14.512C10.0232 14.7622 10.4038 14.7622 10.6039 14.512L13.5636 10.8123C13.8255 10.485 13.5924 10 13.1732 10H7.25381Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25381 9C6.83456 9 6.60147 8.51503 6.86338 8.18765L9.82307 4.48804C10.0232 4.23784 10.4038 4.23784 10.6039 4.48804L13.5636 8.18765C13.8255 8.51503 13.5924 9 13.1732 9H7.25381Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevron);
export default __webpack_public_path__ + "static/media/double-chevron.8b363aaf6a68a725d3bc406bfa2348f9.svg";
export { ForwardRef as ReactComponent };